import { useTranslation } from "react-i18next";

const stats = [
  { value: "15+", labelKey: "hero_stat1_label" },
  { value: "500+", labelKey: "hero_stat2_label" },
  { value: "98%", labelKey: "hero_stat3_label" },
  { value: "3,000+", labelKey: "hero_stat4_label" },
];

export default function Hero() {
  const { t } = useTranslation();

  const handleScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4b4a2e96c66801f98251757af0000bbb.jpg"
          alt="Nice Accounting Office"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1C2331]/85 via-[#1C2331]/70 to-[#1C2331]/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-28 pb-20">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-[#F2C4B5] text-sm font-semibold tracking-widest uppercase mb-5">
            <span className="w-8 h-px bg-[#D4927A]" />
            {t("hero_tag")}
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {t("hero_h1_1")}
            <span className="block text-[#F2C4B5]">{t("hero_h1_2")}</span>
            {t("hero_h1_3")}
          </h1>

          <p className="text-white/75 text-base md:text-lg leading-relaxed mb-10 max-w-xl">
            {t("hero_desc")}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => handleScroll("#contact")}
              className="flex items-center justify-center gap-2 bg-[#D4927A] hover:bg-[#C07F6A] text-white font-semibold px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              {t("hero_cta1")}
              <i className="ri-arrow-right-line" />
            </button>
            <button
              onClick={() => handleScroll("#accounting-services")}
              className="flex items-center justify-center gap-2 border border-white/50 hover:border-white text-white font-semibold px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              {t("hero_cta2")}
              <i className="ri-briefcase-line" />
            </button>
          </div>
        </div>

        {/* Stats row */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl">
          {stats.map((stat) => (
            <div
              key={stat.labelKey}
              className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-5 py-4 text-center"
            >
              <p className="text-3xl font-bold text-[#F2C4B5]">{stat.value}</p>
              <p className="text-white/70 text-xs mt-1 leading-snug">{t(stat.labelKey)}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 z-10 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">{t("hero_scroll")}</span>
        <i className="ri-arrow-down-line text-white/50 text-lg" />
      </div>
    </section>
  );
}
